<p-table #dtEvaluaciones [value]="evaluacioneService.evaluacionesSolicitud()" [columns]="cols" responsiveLayout="scroll" [rows]="10"
         [globalFilterFields]="['idSolicitudEval','idSolicitud','estado','fechaInicio']"
         [paginator]="true" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
         [styleClass]="'p-datatable-sm'"
         currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} evaluaciones"
         selectionMode="multiple" [rowHover]="true" dataKey="id">
    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">Evaluaciones: ({{ evaluacioneService.evaluacionesSolicitud().length }})</h5>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="idSolicitudEval">#Solicitud Eval
                <p-sortIcon field="idSolicitudEval"></p-sortIcon>
            </th>
            <th>Técnico(s) asignado(s)</th>
            <th pSortableColumn="estado">Estado
                <p-sortIcon field="estado"></p-sortIcon>
            </th>
            <th pSortableColumn="fechaInicio">Fecha Inicio
                <p-sortIcon field="fechaInicio"></p-sortIcon>
            </th>
            <th>Fecha Fin</th>
            <th>Opción</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-evaluaciones>
        <tr>
            <td>
                <span class="p-column-title">Solicitud Eval</span>
                {{ evaluaciones.idSolicitudEval }}
            </td>
            <td>
                <ng-container *ngFor="let usuario of getUsuariosName(evaluaciones.nombreUsuariosAsig)">
                    <p-tag severity="info" styleClass="text-base mr-1 mb-1" [pTooltip]="'Técnico ' + usuario +' asignado a la evaluación'">
                        {{ usuario }}</p-tag>
                </ng-container>
            </td>
            <td>
                <span class="p-column-title">Estado</span>
                <p-tag [style]="tagStyle(evaluaciones.estado)"
                       [value]="evaluaciones.estado==true?'Activo':'Inactivo'"></p-tag>
            </td>
            <td>
                <span class="p-column-title">Fecha Inicio</span>
                {{ evaluaciones.fechaInicio }}
            </td>
            <td>
                <span class="p-column-title">Fecha Fin</span>
                {{ evaluaciones.fechaFin!=null?evaluaciones.fechaFin:'N/A' }}
            </td>
            <td>
                <p-button icon="pi pi-eye" class="p-button-rounded mr-2"
                          [routerLink]="['/officials/solicitud-evaluacion/',evaluaciones.idProyecto, evaluaciones.idSolicitud]"
                          [queryParams]="{idSolicitudEval: evaluaciones.idSolicitudEval}"
                          [rounded]="true" [outlined]="true"
                          pTooltip="Ir a evaluación" severity="info"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

